import { ReactNode } from "react";
import { PencilRuler, Layers2, FileDown, ChartBarBig } from "../ui/icons";
import { FloatingIconButton } from "../ui/floating-icon-button";
import { ButtonGroup } from "../ui/button-group";
import { cn } from "../../lib/utils";
import ZoomControl from "./ZoomControl";

interface MapActionBarProps {
  handleToggleModal: VoidFunction;
  showModal: boolean;
  handleToggleToolsMenu?: VoidFunction;
  showToolsMenu?: boolean;
  handleToggleReportModal?: VoidFunction;
  showReportModal?: boolean;
  showLegend?: boolean;
  onLegendToggle?: VoidFunction;
  /** Rendered below the zoom buttons, inside the same floating container. */
  children?: ReactNode;
}

export function MapActionBar({
  handleToggleModal,
  showModal,
  handleToggleToolsMenu,
  showToolsMenu,
  handleToggleReportModal,
  showReportModal,
  showLegend,
  onLegendToggle,
  children,
}: MapActionBarProps) {
  const modalOpened = showModal || showToolsMenu || showReportModal;

  return (
    <div
      id="mapActionBar"
      data-tour="functionalities-menu"
      role="toolbar"
      aria-label="Menu de funcionalidades"
      className={cn(
        "fixed top-[145px] pointer-events-auto transition-[left] duration-300 ease-in-out z-action-bar",
        modalOpened ? "left-[400px] pl-6" : "left-[8px]"
      )}
    >
      <ButtonGroup orientation="vertical" gap="default">
        <FloatingIconButton
          onClick={handleToggleModal}
          aria-label="Toggle Modal"
          state={showModal ? "active" : "default"}
          title="Camadas e Cenários"
          size="sm"
        >
          <Layers2 />
        </FloatingIconButton>

        <FloatingIconButton
          onClick={onLegendToggle}
          state={showLegend ? "active" : "default"}
          aria-label="Toggle Legend"
          title="Dados Técnicos e Legendas"
          size="sm"
        >
          <ChartBarBig />
        </FloatingIconButton>

        {handleToggleReportModal && (
          <FloatingIconButton
            onClick={handleToggleReportModal}
            state={showReportModal ? "active" : "default"}
            aria-label="Toggle Report Modal"
            title="Criar Relatório"
            size="sm"
          >
            <FileDown />
          </FloatingIconButton>
        )}
        {handleToggleToolsMenu && (
          <FloatingIconButton
            onClick={handleToggleToolsMenu}
            state={showToolsMenu ? "active" : "default"}
            aria-label="Toggle Tools Menu"
            title="Ferramentas"
            size="sm"
          >
            <PencilRuler />
          </FloatingIconButton>
        )}
        <ZoomControl />
      </ButtonGroup>
      {children}
    </div>
  );
}

export default MapActionBar;
